import Vue from "vue";
import Vuex from "vuex";
import sse from "@/store/modules/sse";
import auth from "@/store/modules/auth";
import data from "@/store/modules/data";
import drawer from "@/store/modules/drawer";
import snackbar from "@/store/modules/snackbar";
import breadcrumbs from "@/store/modules/breadcrumbs";
import notice from "@/store/modules/notice";
Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    sse,
    auth,
    data,
    drawer,
    snackbar,
    breadcrumbs,
    notice,
  },
  // strict: process.env.NODE_ENV !== "production"
});
